<template>
<div>
    <div class="form form-horizontal">
        <div class="">
            <div class="form-group">
                <label class="col-md-4 control-label">Smithsonian Number</label>
                <div class="col-md-8">
                    <input type="text" class="form-control" v-model="crSearchDto.smithsonianNumber" autocomplete="off">
                </div>
            </div>
        </div>
        <div class="">
            <div class="form-group">
                <label class="col-md-4 control-label">Site Name</label>
                <div class="col-md-8">
                    <input type="text" class="form-control" v-model="crSearchDto.siteName" autocomplete="off">
                </div>
            </div>
        </div>
        <div class="">
            <div class="form-group">
                <div class="col-md-1"></div>
                <div class="col-md-8">
                    <label class="control-label text-label" for="crShowInactive">Show Inactive</label>
                    <input type="checkbox" v-model="crSearchDto.showInactive" class="form-check-input" id="crShowInactive" style="width: 15px; height: 15px;"/>
                </div>
            </div>
        </div>
        <loader v-if="crSearchLoading"></loader>
        <div v-if="searchGridSpec.tableData.length > 0" class="well">
            <v-client-table :data="searchGridSpec.tableData" :columns="searchGridSpec.columns" :options="searchGridSpec.options">
                <template slot="add" slot-scope="props">
                    <div style="text-align: center">
                        <a v-show="!props.row.disabled" class="fa fa-plus" style="font-size: 18px;" v-on:click="clickCulturalResource(props.row)"></a>
                    </div>
                </template>
            </v-client-table>
        </div>
        <div v-if="noSearchResults" class="alert alert-info">
            <span>No Cultural Resources Found</span>
        </div>
        <div class="">
            <button name="buttonSearch" class="btn btn-primary col-md-3" v-on:click="searchCulturalResource()"> Search </button>
        </div>
    </div>
</div>
</template>

<script>
import culturalResourceService from '@/services/culturalResourceService'
import loggingService from '@/services/util/loggingService'
import loader from '@/components/Loader.vue'

export default {
    name: 'CulturalResourceSearch',
    components: {
        loader
    },
    props: [
        'addCulturalResource',
        'resultFilter'
    ],
    data: function () {
        return {
            isDebug: false,
            crSearchLoading: false,
            noSearchResults: false,
            crSearchDto: {},
            searchGridSpec: {
                columns: ['smithsonianNumber', 'siteName', 'add'],
                options: {
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        smithsonianNumber: 'Smithsonian Number',
                        siteName: 'Site Name',
                        add: 'Add'
                    }
                },
                tableData: []
            }
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Cultural Resource Search', message)
        },
        searchCulturalResource () {
            this.log('Searching')
            this.crSearchLoading = true
            culturalResourceService.search(this.$http, this.crSearchDto).then(response => {
                var filteredResults = (this.resultFilter) ? this.resultFilter(response.data) : response.data
                this.log('Filtered Result is ' + filteredResults.length)
                this.searchGridSpec.tableData = response.data.map(cr => {
                    var approved = false
                    filteredResults.forEach(goodCR => {
                        if (goodCR.culturalResourceId === cr.culturalResourceId) {
                            approved = true
                        }
                    })
                    if (approved) {
                        cr.disabled = false
                    } else {
                        cr.disabled = true
                    }
                    return cr
                })
                this.noSearchResults = (response.data.length === 0)
                this.crSearchLoading = false
                this.log('Seach complete: ' + response.data.length)
            })
        },
        clickCulturalResource (culturalResource) {
            this.log('calling parent to add ' + culturalResource.culturalResourceId)
            //var cr = this.searchGridSpec.tableData.filter(x => { return x.culturalResourceId === culturalResourceId })[0]
            this.addCulturalResource(culturalResource)
        }
    }
}
</script>



// WEBPACK FOOTER //
// CulturalResourceSearch.vue?1a7041fc